import { guides } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function GuideSection() {
  return (
    <section id="guide" className="py-16 md:py-24 bg-background-100 border-y border-background-200">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <SectionHeading
          eyebrow="How to browse"
          title="四步找到想看的内容"
          desc="第一次来到 51视频内容页，可以按下面的顺序浏览：先确定方向，再逐步缩小范围，最后用动态确认更新，整个过程不需要注册账号。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {guides.map((item) => (
            <article
              key={item.step}
              data-reveal
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span className="font-num text-3xl md:text-4xl font-extrabold text-background-300">
                {item.step}
              </span>
              <span className="mt-4 w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-xl">
                <i className={item.icon} />
              </span>
              <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}